import { useContext } from 'react';
import { TroubleShootingHandler } from '../../../../Pages/MainComponents/TroubleShooting/TroubleShooting';
import AudioService from '../../../../Services/AudioService';
import { CustomerServiceContactService } from '../../../../Services/Configuration/CustomerServiceContactService';
import { goToUrl } from '../../../../Utils/NavigationUtils';
import { RedoHLAAContext, RedoHLAAState } from '../RedoHLAAContext';
import { TransitionAction } from '../../../../Pages/MainComponents/MainView/MainViewModel';
import { MainViewContext } from '../../../../Pages/MainComponents/MainView/MainViewContext';

function useRedoHLAATroubleShootingHandler(): TroubleShootingHandler {
    const { setRedoHLAAState, info } = useContext(RedoHLAAContext);

    const viewContext = useContext(MainViewContext);

    const onStartAudioContext = async () => {
        await AudioService.serviceInstance.createNewAudioContext();
    };

    const retryBeepConfirmationThresholdReached = () =>
        info.current.retryBeepConfirmationCount >=
        info.current.retryBeepConfirmationCountThreshold;

    const onRetry = async () => {
        await onStartAudioContext();
        setRedoHLAAState(RedoHLAAState.OneSideSetUp);
    };

    const startMobileDeviceUnmutedCheck = () => {
        viewContext.doTransition(
            TransitionAction.DoMobileDeviceUnmutedCheckDialogOpen
        );
    };

    const openConnectionSupportLink = () => {
        goToUrl(
            CustomerServiceContactService.getCountrySpecificOrionConnectionCheckAddress(
                false
            ),
            true
        );
    };

    const openCustomerServiceContactHyperLink = () => {
        goToUrl(
            CustomerServiceContactService.getCountrySpecificOrionCustomerServiceContact(
                false
            ),
            true
        );
    };

    const linkCallBacks = {
        connectionCheckSupport: openConnectionSupportLink,
        startMobileDeviceUnmutedCheck: startMobileDeviceUnmutedCheck,
        customerSupport: openCustomerServiceContactHyperLink,
    };

    return {
        onRetry,
        linkCallBacks,
        retryBeepConfirmationThresholdReached,
    };
}

export default useRedoHLAATroubleShootingHandler;
